export const round = (num: number, precision: number = 0) => {
  return +(
    Math.round((num + `e+${precision}`) as unknown as number) + `e-${precision}`
  );
};
